<div class="flex justify-center items-center h-screen w-full bg-[#505A78]">
  <div class="bg-white w-full h-full flex p-5 justify-center items-center rounded-tl-xl flex-col">
    <div class="text-2xl font-bold mb-2">Welcome Back, {{ (authUserData$ | async)?.User?.FullName }}</div>
    <div class="flex flex-row flex-wrap justify-center items-center gap-5 ">
      @for (groups of groupedModules$ | async; track groups) {
        @for (module of groups.Modules; track module) {
          <div class="flex flex-row justify-center items-center text-center rounded-lg p-5 w-64 h-20 max-h-20 bg-[#505A78] hover:cursor-pointer" [routerLink]="module.RouterLink">
            <a >
              <h3 class="text-white">{{ module.DisplayName | titlecase }}</h3>
            </a>
          </div>
        }
      } @empty {
        <h3>No Modules Available</h3>
      }
    </div>
  </div>
  </div>
